import { ITrainControlsResponse } from "../interfaces";
import { toFakeUtc } from "@framework/provider-asu";

export const mergeRecorderModeControls = (
  prevControls: ITrainControlsResponse[],
  nextControls: ITrainControlsResponse[],
  windowStart: string,
  dbTz: number,
) => {
  const prevMap = new Map(prevControls.map(ctrl => [ctrl.idSchemeObject, ctrl]));
  const windowStartTime = new Date(windowStart).getTime();

  return nextControls.map(ctrl => {
    if (ctrl.ldd !== null) return ctrl;

    const prev = prevMap.get(ctrl.idSchemeObject);
    if (prev?.ldd && toFakeUtc(prev.ldd, dbTz).getTime() >= windowStartTime) return prev;

    return ctrl;
  });
};
